import * as Yup from 'yup';
import { StoryCharacterEnum } from '../../../interfaces/character.interface';

export const createCharacterValidationSchema = (characterOutlineByUser: any, continueWithoutImage: boolean) => {
  return Yup.object().shape({
    characterType: Yup.string().required('Character Type is required'),
    age:
      continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
        ? Yup.number()
          .required('Age is required')
          .min(1, 'Age must be at least 1')
          .max(100, 'Age cannot exceed 100')
        : Yup.number(),
    ageUnit:
      continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
        ? Yup.string().required('Age unit is required')
        : Yup.string(),
    gender:
      continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
        ? Yup.string().required('Gender is required')
        : Yup.string(),
    mics:
      continueWithoutImage && characterOutlineByUser?.characterType !== StoryCharacterEnum.human
        ? Yup.string()
        : Yup.string(),
    // for animal character type
    animalType:
      (characterOutlineByUser?.characterType !== StoryCharacterEnum.human && !continueWithoutImage) ||
      (continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.animal)
        ? Yup.string().required('Animal Type is required')
        : Yup.string().nullable(),
    // for fictional character type
    character:
      (characterOutlineByUser?.characterType !== StoryCharacterEnum.human && !continueWithoutImage) ||
      (continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.fictional)
        ? Yup.string().required('Character Name is required')
        : Yup.string(),
    skinTone:
        continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
            ? Yup.string()
            : Yup.string().nullable(),
    hairColor:
        continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
            ? Yup.string()
            : Yup.string().nullable(),
    hairStyle:
        continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
            ? Yup.string()
            : Yup.string().nullable(),
    eyeColor:
        continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
            ? Yup.string()
            : Yup.string().nullable(),
    wearsUses:
        continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
            ? Yup.string()
            : Yup.string().nullable(),
    otherFeatures:
        continueWithoutImage && characterOutlineByUser?.characterType === StoryCharacterEnum.human
            ? Yup.string()
            : Yup.string().nullable(),
  });
};
